import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Announcement, AnnouncementsService } from 'src/app/services/announcements.service';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.css']
})
export class AnnouncementsComponent {
  items: Announcement[] = [];
  loading = false;
  showDeleteModal = false;
  deleteModalBody = '';
  open = false;
  mode: 'add' | 'edit' | 'view' = 'add';
  selectedId = '';
  isError = false;
  errorMessage = '';
  form = new FormGroup({
    text: new FormControl('', [Validators.required]),
    active: new FormControl(false),
  });

  constructor(private announcementsService: AnnouncementsService) { }

  async ngOnInit() {
    await this.fetchItems();
  }

  async fetchItems() {
    this.loading = true;
    try {
      this.items = await this.announcementsService.list();
    } catch (error: any) {
      this.showError(error?.error?.errorMessages?.[0]?.message || 'ANNOUNCEMENTS.LOAD_FAILED');
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  onAdd() {
    this.form.enable();
    this.mode = 'add';
    this.selectedId = '';
    this.form.reset({ text: '', active: false });
    this.isError = false;
    this.open = true;
  }

  onEdit(item: Announcement) {
    this.form.enable();
    this.mode = 'edit';
    this.selectedId = item.id;
    this.form.patchValue({
      text: item.text,
      active: item.active,
    });
    this.isError = false;
    this.open = true;
  }

  openRow(item: Announcement) {
    this.form.enable();
    this.mode = 'view';
    this.selectedId = item.id;
    this.form.patchValue({
      text: item.text,
      active: item.active,
    });
    this.isError = false;
    this.open = true;
    this.form.disable();
  }

  onDelete(item: Announcement) {
    this.selectedId = item.id;
    this.deleteModalBody = 'ANNOUNCEMENTS.DELETE_BODY';
    this.showDeleteModal = true;
  }

  async onDeleteConfirm(confirmed: boolean) {
    if (confirmed && this.selectedId) {
      try {
        await this.announcementsService.delete(this.selectedId);
        await this.fetchItems();
      } catch (error: any) {
        this.showError(error?.error?.errorMessages?.[0]?.message || 'ANNOUNCEMENTS.DELETE_FAILED');
      }
    }
    this.showDeleteModal = false;
    this.selectedId = '';
  }

  async submit() {
    if (this.mode === 'view') {
      return;
    }
    if (this.form.invalid) {
      this.showError('ANNOUNCEMENTS.TEXT_REQUIRED');
      return;
    }

    const body = {
      text: this.form.value.text as string,
      active: this.form.value.active === true,
    };

    try {
      if (this.mode === 'edit') {
        await this.announcementsService.update(this.selectedId, body);
      } else {
        await this.announcementsService.create(body);
      }
      this.open = false;
      await this.fetchItems();
    } catch (error: any) {
      this.showError(error?.error?.errorMessages?.[0]?.message || 'ANNOUNCEMENTS.SAVE_FAILED');
    }
  }

  closeModal() {
    this.open = false;
    this.isError = false;
    this.form.enable();
  }

  showError(message: string) {
    this.isError = true;
    this.errorMessage = message;
  }
}
